import { GET_NEW_REQUEST_DATA, GET_OLD_REQUEST_DATA } from "../constants";
import axios from "axios";
import { ApiCall } from "../../utils/index";

export const getNewRequestData = (request, page, sortField, sortOrder, row_count) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.get(`/request/pending?sort_field=${sortField}&sort_order=${sortOrder}&page=${page}&page_size=${row_count}`, token);
    dispatch({ type: GET_NEW_REQUEST_DATA, payload: result.data });
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

export const getOldRequestData =
  (request, page, sortField, sortOrder, row_count) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/request/complete_rejected?sort_field=${sortField}&sort_order=${sortOrder}&page=${page}&page_size=${row_count}`,
        token
      );
      dispatch({ type: GET_OLD_REQUEST_DATA, payload: result.data });
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

export const acceptExtension = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.patch(
      `/request/extend_activity/${request.id}`,
      {
        estimated_time: new Date(request.allowance).toISOString(),
      },
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

export const acceptTransfer = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.patch(
      `/request/transfer_activity/${request.id}`,
      {},
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

export const acceptBackToAdmin = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.patch(
      `/request/transfer_by_admin/${request.reqId}`,
      {
        user_id: request.user_id,
        user_email: null,
        activity_assignment_mapping_id: request.activity_assignment_mapping_id,
      },
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

export const rejectRequest = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.patch(
      `/request/reject/${request.id}`,
      {},
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};
